import React from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import Abtslider1 from '../../assets/images/abtslide_1.png';
import Abtslider2 from '../../assets/images/abtslide_2.png';
import Abtslider3 from '../../assets/images/abtslide_3.png';
import Abtslider4 from '../../assets/images/abtslide_4.png';
import Abtslider5 from '../../assets/images/abtslide_5.png';

const Slider = {
   breakpoints: {
        0: {
            slidesPerView: 1,
        },
        600: {
            slidesPerView: 2.5,
        },
        1000: {
            slidesPerView: 4,
        },
    },
};

const abtSlideImages = [
    Abtslider1,
    Abtslider2,
    Abtslider3,
    Abtslider4,
    Abtslider5,
    Abtslider4,
    Abtslider4,
    Abtslider5,
    Abtslider4,
    Abtslider4,
    Abtslider5,
    Abtslider4,
];

function About() {
    return (
        <>
            <section className="about_us_section">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge">Despre noi</span>
                        <h2>
                            Cunoaște echipa <br/> <span style={{fontSize: 4.5 + 'rem'}}>LUMO</span>
                        </h2>
                        <p>
                        Suntem echipa din spatele unei idei simple: să schimbăm <br/> modul în care românii interacționează cu serviciile.

                        </p>
                    </div>
                </div>
                <div className="about_slider row_am" data-aos="fade-in" data-aos-duration={1500}>
                    <Swiper className="mySwiper" id="about_slider" {...Slider} spaceBetween={15} slidesPerView={4}>
                        {abtSlideImages.map((image, index) => (
                            <SwiperSlide key={index} className="item">
                                <div className="abt_slides">
                                    <img src={image} alt="image" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="container">
                    <div className="row abt_text" data-aos="fade-up" data-aos-duration={1500}>
                        <div className="col-md-5">
                            <h2>
                            Am creat <span>LUMO</span> ca răspuns la o nevoie reală: servicii locale, <span>fără complicații</span>
                            </h2>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'justify'}}>
                            <p>
                            LUMO este construit de o echipă tânără de profesioniști care cred că lucrurile bune se pot face mai simplu, mai curat și mai digital. Am pornit cu o idee clară: România are nevoie de o platformă care să conecteze oamenii cu serviciile de zi cu zi, într-un mod modern, intuitiv și de încredere.
                            </p>
                            <p>
                            Vrem să contribuim activ la digitalizarea pieței serviciilor din România și să susținem profesioniștii locali printr-un ecosistem clar, transparent și eficient. Știm că timpul e o resursă tot mai prețioasă, iar misiunea noastră este să-l respectăm — atât pentru cei care oferă, cât și pentru cei care caută servicii.
                            </p>
                            <p>
                            Ne ghidăm după valori simple: transparență, eficiență, încredere și beneficii reale pentru ambele părți. Suntem atenți la detalii, conectați la realitate și deschiși la tot ce poate îmbunătăți experiența celor care aleg LUMO.
                            </p>
                            <p>
                            Nu ne dorim să fim doar „încă o aplicație”, ci o soluție completă, umană, adaptată stilului de viață modern.
                            </p>

                            
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default About;
